import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresAtividadeService } from "../services/indicadores-atividade.service";
import { IndicadoresPgAtividadeService } from "../services/indicadores-pg-atividade.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAtividadeResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAtividadeSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAtividadeListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAtividadeService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList();
  }
}